import {
  fetchEditorImages,
  fetchEditorImagesTags,
  displaySidebarImages,
  displaySidebarImagesTag,
  sidebarLoader,
} from '~src/sidebar/index';

import { getState } from '~src/state';
import _ from 'lodash';

export const handleSidebarImages = async (forceFetch = false) => {
  sidebarLoader('editor-sidebar-images');
  const currentTag = getState('sidebarCurrentImagesTag', 'NO_TAG');

  if (_.isEmpty(window.editorConfig.sidebarTags)) {
    const { tags } = await fetchEditorImagesTags();
    window.editorConfig.sidebarTags = tags;
  }

  displaySidebarImagesTag();
  const { images } = await fetchEditorImages(forceFetch);
  window.editorConfig.sidebarImages[currentTag] = images;
  displaySidebarImages();
};
